import * as React from 'react';
import { Button } from "../..";
export var ResetButton = function ResetButton(_ref) {
  var id = _ref.id,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  return React.createElement(Button, {
    id: id ? "".concat(id, "-reset-btn") : undefined,
    emphasis: "medium",
    palette: "primary",
    disabled: disabled,
    type: "button",
    onClick: onClick,
    lss: {
      mr: 'xxl',
      ml: 'lg'
    }
  }, children || 'Discard Changes');
};